// Theme constants ported from the source app.
// Semantic split enforced: gold for commit + anticipation, terracotta for
// primary CTAs only, sage for accepted commitment / coverage / "it's happening".
export const colors = {
  surface: "#FBF9F6",
  onSurface: "#2B312A",
  surfaceSecondary: "#F1EDE4",
  onSurfaceSecondary: "#3F463E",
  surfaceTertiary: "#E7EAE3",
  surfaceInverse: "#2B312A",
  onSurfaceInverse: "#FBF9F6",
  brand: "#B08A50",           // commit gold — people accent, big counts, Almost There
  brandPrimary: "#C85A3A",    // terracotta — reserved for primary CTAs (FAB, invite CTA)
  onBrandPrimary: "#FFFFFF",
  brandSecondary: "#6B8065",  // sage — things accent + committed
  onBrandSecondary: "#FFFFFF",
  brandTertiary: "#E3C28D",
  onBrandTertiary: "#2B312A",
  success: "#6B8065",         // sage — accepted commitment, coverage, "It's happening"
  border: "#E3C28D",
  borderSoft: "#E2DCD0",
  divider: "#E2DCD0",
  muted: "#8A8778",
  error: "#A84A3B",
};

export function statusColor(status) {
  switch (status) {
    case "gathering":
      return colors.brand;              // gold — anticipation
    case "threshold-crossed":
    case "happening":
      return "#7A9670";                 // living sage — momentum, spring leaves
    case "completed":
      return "#8B9878";                 // softer sage — reflective memory
    case "closed-not-met":
      return colors.muted;
    case "cancelled":
    case "draft":
    default:
      return colors.muted;
  }
}

export function statusLabel(status) {
  switch (status) {
    case "draft": return "Draft";
    case "gathering": return "🌱 Gathering";
    case "threshold-crossed": return "🌿 It's Happening";
    case "happening": return "🌿 Happening";
    case "completed": return "✿ Completed";
    case "closed-not-met": return "Didn't gather";
    case "cancelled": return "Cancelled";
    default: return status;
  }
}

export function statusLabelDynamic(status, peopleCommitted, peopleNeeded, isRetry) {
  if (status === "gathering") {
    if (peopleNeeded > 0 && peopleCommitted / peopleNeeded >= 0.75) return "🔥 Almost There";
    if (isRetry) return "🔄 Trying Again";
    return "🌱 Gathering";
  }
  return statusLabel(status);
}

export function tintForStatus(status) {
  // Emotional arc: gathering (neutral) -> Almost There (gold, in status pill
  // only, card stays neutral) -> It's Happening (living sage, momentum) ->
  // Completed (archival cream, memory). Two greens, one alive, one settled.
  if (status === "threshold-crossed" || status === "happening") return "#D5E0D2";
  if (status === "completed") return "#E4E9DC";
  if (status === "draft") return "#F5F1E8";
  return "#FBF9F6";
}
